/* index.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U8HPE%7Bpadding-block%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aNu0LYbGa%7Blist-style-type%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D");
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
const styles = {
  outerContainer: "_4c065U8HPE _0aNu0LYbGa _43nrzTPgdg"
};
type Props = {
  asListItem?: boolean;
};
export const ListItemSkeleton = ({
  asListItem = false
}: Props): React.ReactNode => <Box xcss={styles.outerContainer} as={asListItem ? 'li' : undefined}>
		<Inline spread="space-between" alignBlock="center" space="space.200">
			<Skeleton width="32px" height="32px" />
			<Stack space="space.050" grow="fill">
				<Skeleton height={16} width="100%" />
				<Skeleton height={16} width="100%" />
			</Stack>
		</Inline>
	</Box>;